'use client'

import Image from 'next/image'
import NewsSideItem from '@/components/news/NewsSideItem'
import { NewsItem, useGetMostViewedNewsQuery } from '@/redux/services/newsApi'
import StatsComponent from '../StatsComponent'
import Link from 'next/link'
import NewsDate from './NewsDate'

const Banner = ({ data }: { data: NewsItem[] }) => (
    <>
        <Link
            href={`/news/${data[0].translit}`}
            className='news__banner-main'
        >
            <div className='news__banner-main-img-wrapper'>
                <div className='news__banner-main-img'>
                    <Image
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${data[0]?.intro}`}
                        fill
                        alt='banner-image'
                    />
                </div>
            </div>
            <div className='news__banner-main-text'>
                <ul className='news__tags'>
                    {data[0] && data[0].tags_id && data[0]?.tags_id
                        .filter(tag => tag.id < 7)
                        ?.map(tag => (
                            <li
                                key={tag.title}
                                className={'news__tag'}
                            >
                                {tag.title}
                            </li>
                        ))}
                    <li className='news__tag-date'>
                        <NewsDate date={data[0].creation_date} />
                    </li>
                </ul>
                <Link
                    className='news__banner-main-title-link'
                    href={`/news/${data[0].translit}`}
                >
                    <h2 className='news__banner-main-title'>{data[0]?.title}</h2>
                </Link>
                <p className='news__description'>{data[0]?.subtitle}</p>
                <StatsComponent
                    likes={data[0]?.likes}
                    views={data[0]?.views}
                />
            </div>
        </Link>
        {data.length ? (
            <ul className='news__banner-side-list'>
                {data.slice(1, 6)?.map(item => (
                    <NewsSideItem
                        key={item.id}
                        item={item}
                    />
                ))}
            </ul>
        ) : null}
    </>
)

const NewsBanner: React.FC<{ existedData?: any }> = ({ existedData }: { existedData?: any }) => {
    const { data } = useGetMostViewedNewsQuery({
        type: 'articles'
    })

    return (
        <div className='news__banner'>
            {!data?.length ? (
                <div>Loading...</div>
            ) : data[0] ? (
                <Banner data={existedData ? existedData : data} />
            ) : null}
        </div>
    )
}

export default NewsBanner
